import { DocumentationManual } from '@/hooks/useDocumentation';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Clock } from 'lucide-react';
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';

interface VersionHistoryProps {
  versions: DocumentationManual[];
  onPublish: (manualId: string) => void;
  isPublishing: boolean;
}

export function VersionHistory({ versions, onPublish, isPublishing }: VersionHistoryProps) {
  return (
    <Card className="p-6">
      <h3 className="font-semibold mb-4">Versiegeschiedenis</h3>
      <div className="space-y-4">
        {versions.map((version) => (
          <div key={version.id} className="border rounded-lg p-4 space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="font-semibold">v{version.version}</span>
                {version.is_current && (
                  <Badge variant="default" className="gap-1">
                    <CheckCircle2 className="h-3 w-3" />
                    Huidig
                  </Badge>
                )}
              </div>
              {!version.is_current && (
                <Button
                  onClick={() => onPublish(version.id)}
                  disabled={isPublishing}
                  size="sm"
                  variant="outline"
                >
                  Publiceren
                </Button>
              )}
            </div>

            {version.version_notes && (
              <p className="text-sm text-muted-foreground">{version.version_notes}</p>
            )}

            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                <span>
                  Aangemaakt:{' '}
                  {format(new Date(version.created_at), 'dd MMM yyyy HH:mm', { locale: nl })}
                </span>
              </div>
              {version.published_at && (
                <div className="flex items-center gap-1">
                  <CheckCircle2 className="h-3 w-3" />
                  <span>
                    Gepubliceerd:{' '}
                    {format(new Date(version.published_at), 'dd MMM yyyy HH:mm', { locale: nl })}
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
